import { memo } from 'react'
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react'
import path from 'ramda/src/path'
import has from 'ramda/src/has'
import { orNull, isObj } from 'root/src/shared/util/ramdaPlus'
import StringWithLink from 'root/src/client/web/static/reusable/StringWithLink'
import TertiaryBody from 'root/src/client/web/typography/TertiaryBody'
import TitleFormText from 'root/src/client/web/typography/TitleFormText'
import SubTitle from 'root/src/client/web/typography/SubTitle'
import orEmpty from 'root/src/shared/util/orEmpty'

const styles = {
	inputWrapper: {
		display: 'flex',
		position: 'relative',
		flexDirection: 'column',
		marginBottom: 25,
		width: '100%',
		'@media (max-width: 600px)': {
			width: 320,
		},
	},
	subFieldText: {
		marginTop: 8,
	},
	inline: {
		display: 'inline',
	},
	labelFieldText: {
		display: 'flex',
		alignItems: 'center',
		marginBottom: 8,
		fontSize: 8,
	},
	subTextLabel: {
		lineBreak: 'anywhere',
		marginBottom: 20,
		marginTop: -8,
		'& div': {
			fontSize: 18,
			color: '#707070',
		},
	},
	icon: {
		height: 20,
		width: 20,
		marginRight: 7,
	},
	over: {
		zIndex: 1,
	},
}
const InputWrapper = memo(
	({
		variant,
		subFieldText,
		labelFieldText,
		children,
		formType,
		subTextLabel,
		fieldHalfWidth,
		over,
		fieldTheme,
		hideInput,
	}) => {
		const dynamicStyles = {
			...styles,
			...fieldTheme,
		}

		if (hideInput) {
			return children
		}

		return (
			<div
				css={{
					...dynamicStyles.inputWrapper,
					...orEmpty(formType === 'universalForm', dynamicStyles.inline),
					...orEmpty(fieldHalfWidth, dynamicStyles.fieldHalfWidth),
					...orEmpty(over, dynamicStyles.over),
				}}
			>
				{orNull(
					labelFieldText,
					<div css={dynamicStyles.labelFieldText}>
						{labelFieldText && (
							has('icon', labelFieldText[0]) && (
								<img
									src={path(['icon', 'src'], labelFieldText[0])}
									alt="icon"
									css={dynamicStyles.icon}
								/>
							))}
						<TitleFormText variant={variant}>{labelFieldText}</TitleFormText>
					</div>,
				)}
				{orNull(
					subTextLabel,
					<div css={dynamicStyles.subTextLabel}>
						{isObj(subTextLabel)
							? <StringWithLink {...subTextLabel} />
							: <SubTitle>{subTextLabel}</SubTitle>
						}
					</div>,
				)}
				{children}
				{orNull(
					subFieldText,
					<div
						css={dynamicStyles.subFieldText}
					>
						<TertiaryBody
							css={dynamicStyles.subTextLabel}
						>
							{subFieldText}
						</TertiaryBody>
					</div>,
				)}
			</div>
		)
	},
)

export default InputWrapper
